import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeFleetTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      aircrafts_remaining: [],
      aircrafts_available: [],
      bases: [],
      base_id: null,
      aircraft_id: null,
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.aircrafts_remaining) && Array.isArray(newProps.aircrafts_available) && Array.isArray(newProps.bases)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        aircrafts_remaining: newProps.aircrafts_remaining,
        aircrafts_available: newProps.aircrafts_available,
        bases: newProps.bases,
        loaded: 1,
      });
    }
  }
  
  // Adiciono uma aeronave na escala
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/adicionar/aeronave', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.tituloAeronavesDisponiveisParaEscalaDeTripulacao}</h3>
  <hr/>
  {(this.state.aircrafts_available === null || typeof this.state.aircrafts_available === 'undefined') ?  <div><small><em>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.NenhumaAeronaveDisponivelCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.tabela.Aeronave}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.tabela.Contrato}</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(self.state.aircrafts_available).map(function(k) {
          return (
              <tr>
                <td className="text-center">{self.state.aircrafts_available[k].aircraft.registration}</td>
                {
                  self.state.aircrafts_available[k].contract !== null ?
                    <td className="text-center">{self.state.aircrafts_available[k].contract.name}</td>
                    :
                    ''
                }
              </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <hr/>
  <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.tituloEscalarAeronave}</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.formulario.Aeronave}:</label>
        <Select
          className="form-field-name"
          name="aircraft_id"
          value={this.state.aircraft_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
          options={this.state.aircrafts_remaining}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.formulario.Base}:</label>
        <Select
          className="form-field-name"
          name="base_id"
          value={this.state.base_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'base_id')}
          options={this.state.bases}
        />    
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.formulario.botaoEscalarAeronave}</button>
  </form>
</div>
    );
  }
}

export default ScheduleGradeFleetTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeFleetTab.js